/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Empty1Inputs */

const vi_driverremittance_empty1 = /** @type {(inputs: Driverremittance_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có phiếu nộp quỹ nào.`)
};

/**

* @param {Driverremittance_Empty1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_empty1 = /** @type {((inputs?: Driverremittance_Empty1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Empty1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_empty1(inputs)
});
export { driverremittance_empty1 as "driverRemittance_empty" }